<p>version-component works!</p>
<h3><strong> version = {{version}}</strong></h3>
<h3><strong> project = {{projectName}}</strong></h3>
